import React from "react";
import styled from "styled-components";

const InputWrapperStyle = styled.div.attrs({
  className: "input-wrapper"
})`
  position: relative;
`;

export const InputWrapper = (props) => {
  const { name, children, className } = props;

  return(
    <InputWrapperStyle className={className} data-name-wrapper={name}>
      {children}
    </InputWrapperStyle>
  )
}